import Fuse from 'fuse.js';

import type { AutosuggestAnswer } from './AnswerList';

export const fuzzyFilter = ({
  items,
  searchText,
}: {
  items: AutosuggestAnswer[];
  searchText: string;
}): AutosuggestAnswer[] => {
  const fuse = new Fuse(items, {
    keys: ['name'],
    threshold: 0.4,
    distance: 300,
  });

  const results = fuse.search(searchText);

  return results.map((result) => result.item);
};
